/**
 * Initializes the Peppol dropdown logic for the billing form.
 * Attaches event listeners and sets the initial state.
 */
const initPeppolDropdownLogic = () => {
	const peppolDropdown = document.querySelector('.js-peppol-options');
	const vatLiableRadios = document.querySelectorAll('input[name="btwStatus"]');

	if (!peppolDropdown || vatLiableRadios.length === 0) {
		return;
	}

	/**
	 * Updates the Peppol dropdown's state (enabled/disabled and value)
	 * based on the current selection of the 'VAT liable' radio buttons.
	 */
	const updatePeppolState = () => {
		const vatLiableValue = document.querySelector(
			'input[name="btwStatus"]:checked',
		)?.value;

		if (vatLiableValue === 'yes') {
			peppolDropdown.disabled = false;
			peppolDropdown.value = 'BE:VAT';
		} else {
			peppolDropdown.disabled = true;
			peppolDropdown.value = '';
		}
	};

	vatLiableRadios.forEach(radio => {
		radio.addEventListener('change', updatePeppolState);
	});

	updatePeppolState();
};

export default initPeppolDropdownLogic;
